import { Pipe, PipeTransform } from '@angular/core';
import { RouteService } from '../services/route.service';

@Pipe({
    name: 'route',
    standalone: true
})
export class RoutePipe implements PipeTransform {

    constructor(private routeService: RouteService) {
    }

    transform(routeName: string, args?: any): any {
        return this.routeService.getRelativeRoute(routeName, args);
    }

}
